import DragHandleIcon from '@mui/icons-material/DragHandle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InventoryIcon from '@mui/icons-material/Inventory';
import { Button, Divider, IconButton, Stack, Typography, alpha } from '@mui/material';
import { AuditOfferResponseDto } from '@store/audits/audit-offer/audit-offer.model';
import { ServiceKindTypeEnum } from '@store/settings/serviceKinds';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface OfferDimensionContentProps {
  isTemplate?: boolean;
  offers: AuditOfferResponseDto[];
  operationId: number;
  operationName: string;
  isDraggable?: boolean;
  isExpanded?: boolean;
  toggleExpended: () => void;
}

const OfferDimensionContent = (props: OfferDimensionContentProps) => {
  const { isTemplate, offers, operationId, operationName, isDraggable, isExpanded, toggleExpended } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleManageType = (value: ServiceKindTypeEnum) => {
    switch (value) {
      case ServiceKindTypeEnum.PICKUP:
        return t('global.serviceKindType.pickup');
      case ServiceKindTypeEnum.PROCESSING:
        return t('global.serviceKindType.processing');
      case ServiceKindTypeEnum.RENTING:
        return t('global.serviceKindType.renting');
      case ServiceKindTypeEnum.VALORISATION:
        return t('global.serviceKindType.valorisation');
      case ServiceKindTypeEnum.PACKAGE:
        return t('global.serviceKindType.package');
      case ServiceKindTypeEnum.POSE_WITHDRAWAL:
        return t('global.serviceKindType.pose_withdrawal');
      case ServiceKindTypeEnum.OTHER:
        return t('global.serviceKindType.other');
    }
  };


  return (
    <Stack spacing={2}>
      <Stack direction="row" width="100%" px="15px" py="15px" justifyContent="space-between" borderRadius="4px" bgcolor="#F4F6F8">
        <Stack justifyContent='center' alignItems="start" mr={'3rem'}>
          <Stack direction="row" alignItems="center" spacing={1.3} >
            <Stack sx={{
              backgroundColor: '#4F3FF5',
              borderRadius: '3px',
              alignItems: 'center',
              padding: '4px',
              justifyContent: 'center',
              width: '25px',
              height: '25px'
            }}>
              <InventoryIcon sx={{ color: 'white', width: '18px' }} />
            </Stack>
            <Typography fontSize='14px' fontWeight={700} color="#192133" noWrap>
              {operationName}
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent='end' alignItems={isExpanded ? 'start' : 'center'} spacing={2} ml='1rem'>
          {!isDraggable ? (
            <IconButton sx={{ color: '#03053A' }}>
              <DragHandleIcon />
            </IconButton>
          ) : (
            <IconButton onClick={toggleExpended}>
              {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          )}
        </Stack>
      </Stack>
      <Stack px="15px" justifyContent="space-between" borderRadius="4px" bgcolor="#F4F6F8">
        {isExpanded && (
          offers.map((offer, idx) => (
            <Stack width="100%" key={offer.id}>
              {idx !== 0 && <Divider style={{ border: `1px solid ${alpha('#868F9C', 0.22)}` }} />}
              <Stack direction="row" width="100%" alignItems="center" p="15px">
                <Stack width="155px">
                  <Typography fontSize="14px" fontWeight={700} color="#192133" noWrap>
                    {handleManageType(offer.type as ServiceKindTypeEnum)}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  <Typography fontSize="14px" fontWeight={400} color="#868F9C">
                    {t('audits.offerDimension.comment')}
                  </Typography>
                  <Stack sx={{
                    backgroundColor: '#E9EBEE',
                    borderRadius: '1px',
                    padding: '6px 10px',
                    width: '271px',
                  }}>
                    <Typography fontSize="12px" fontWeight={400} color="#192133">
                      {offer.comment || '-'}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          ))
        )}
      </Stack>
      {!isTemplate && (
        <Stack alignSelf="end">
          <Button variant="contained" color="primary" onClick={() => navigate('add-audit-offer', { state: { operationId: operationId } })}>
            {t('audits.buttons.edit-price-proposal')}
          </Button>
        </Stack>
      )}
    </Stack >
  );
};

export default OfferDimensionContent;
